import React from "react";
import { GeneratorFlagEnum } from "../../../../../model/generator/GeneratorTypes";

interface TFCategorySelectorProps {
    label: string;
    title: string;
    onChange: (value: object) => void;
    isChecked: (queryType: string, queryValue: string) => boolean;
    isDisabled: (value: string) => boolean;
}

const TFCategorySelector = (props: TFCategorySelectorProps) => {
    const { label, title, onChange, isChecked, isDisabled } = props;
    return (
        <div className="tf-form-row">
            <div>
                <label htmlFor={label}>{title}:</label>
            </div>
            <div>
                <div className="form-toggle-group">
                    <input id={`${label}-include`}
                            name={label}
                            type="radio"
                            value={GeneratorFlagEnum.INCLUDE}
                            checked={isChecked(label, GeneratorFlagEnum.INCLUDE)}
                            disabled={isDisabled(label)}
                            onChange={() => onChange({[label]: GeneratorFlagEnum.INCLUDE})}
                    />
                    <label htmlFor={`${label}-include`}>Include</label>
                    <input id={`${label}-exclude`}
                            name={label}
                            type="radio"
                            value={GeneratorFlagEnum.EXCLUDE}
                            checked={isChecked(label, GeneratorFlagEnum.EXCLUDE)}
                            disabled={isDisabled(label)}
                            onChange={() => onChange({[label]: GeneratorFlagEnum.EXCLUDE})}
                    />
                    <label htmlFor={`${label}-exclude`}>Exclude</label>
                    <input id={`${label}-only`}
                            name={label}
                            type="radio"
                            value={GeneratorFlagEnum.ONLY}
                            checked={isChecked(label, GeneratorFlagEnum.ONLY)}
                            disabled={isDisabled(label)}
                            onChange={() => onChange({[label]: GeneratorFlagEnum.ONLY})}
                    />
                    <label htmlFor={`${label}-only`}>Only</label>
                </div>
            </div>
        </div>
                    
    );
}

export default TFCategorySelector;